import apiInit from '../api';

const { get } = apiInit('settings');

export const fetchApiVersion = async () => get(`/app/version`);
